define("ROOM4.CCAProductGallery.CCAProductGallery.AccessoryDescriptions.View", [
  "room4_ccaproductgallery_accessory_descriptions.tpl",
  "Backbone",
], function (room4_ccaproductgallery_accessory_descriptions_tpl, Backbone) {
  "use strict";

  return Backbone.View.extend({
    template: room4_ccaproductgallery_accessory_descriptions_tpl,

    initialize: function initialize(options) {
      this.accessoryDescriptionBlocks =
        (options && options.accessoryDescriptionBlocks) || [];
    },

    getContext: function getContext() {
      return {
        accessoryDescriptionBlocks: this.accessoryDescriptionBlocks,
      };
    },
  });
});
